import { instanceConfig } from './instanceConfig';

export const INSTANCE_DFLT_LANGUAGE = instanceConfig.dfltLanguage;
export const INSTANCE_FIXED_LANGUAGE = instanceConfig.fixedLanguage;

export const INSTANCE_DEFAULT_COUNTRY_CODE = instanceConfig.defaultCountryCode;

export const INSTANCE_DEFAULT_CURRENCY_CODE =
  instanceConfig.defaultCurrencyCode;

export const INSTANCE_PHONE_REG_EX = instanceConfig.validation.phoneRegex;
export const INSTANCE_PHONE_MIN_LENGTH =
  instanceConfig.validation.phoneMinLength;

export const INSTANCE_CONTACT_EMAIL = instanceConfig.contactEmail;
export const INSTANCE_CONTACT_EMAIL2 = instanceConfig.contactEmail2;

export const INSTANCE_WITH_CULTURE_COUNTS = instanceConfig.withCultureCounts;
export const INSTANCE_DEFAULT_CURRENCY_TYPE_ID =
  instanceConfig.defaultCurrencyTypeId;
export const INSTANCE_APP_URL = instanceConfig.app_url;
